var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"logoModal\" class=\"form-validate\" novalidate ng-click=\"ok()\">\n<div class=\"modal-header bg-{{type}}\" style=\"border-top-left-radius: 5px; border-top-right-radius: 5px;\">\n<h4 class=\"modal-title\" id=\"modal-title\"><b>{{model.header}}</b></h4>\n</div>\n<div class=\"text-align-center\" ng-if=\"loading\">\n<span class=\"glyphicon glyphicon-refresh fast-right-spinner\" style=\"font-size: 50px\"></span>\n</div>\n<div class=\"text-align-center remove-bottom-margin\">\n<img ng-src=\"{{base64String}}\" width=\"150\"/>\n</div>\n<div class=\"modal-footer\">\n<button class=\"btn btn-primary\" type=\"button\" ng-click=\"cancel()\" ng-disabled=\"model.loading\">\n{{ 'common.close' | translate }}\n</button>\n</div>\n</form>";
var id1="appLogo.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/common/ui/modal/templates/appLogo.html
// module id = 2501
// module chunks = 1